import { gameModuleStore } from "../store/gameModuleStore";
import { gameModuleService } from "./gameModuleService";

class GameControlService {

    standardSpin = () => {
        gameModuleStore.setSpinSpeedType('standard')
        gameModuleService.startSpin()
        gameModuleStore.setIsForceStop(false)

    }

    fastSpin = () => {
        gameModuleStore.setSpinSpeedType('fast')
        gameModuleService.startSpin()
        gameModuleStore.setIsForceStop(false)
    }

    turboSpin = () => {
        gameModuleStore.setSpinSpeedType('turbo')
        gameModuleService.startSpin()
        gameModuleStore.setIsForceStop(false)
    }


    standardStop = ({ matrix, additional }) => {
        gameModuleService.stopAnimation(matrix)
        gameModuleStore.setAdditional(additional)
        if (gameModuleStore.awaitForceStop) gameModuleStore.setIsForceStop(true)
    }

    fastStop = ({ matrix, additional }) => {
        gameModuleService.stopAnimation(matrix)
        gameModuleStore.setAdditional(additional)
        if (gameModuleStore.awaitForceStop) gameModuleStore.setIsForceStop(true)
    }

    forceStop = () => {
        if (gameModuleService.skippableAnimationPromise.length) {
            gameModuleService.skipAnimations()
        }
        if (gameModuleStore.responseReady && !gameModuleStore.awaitForceStop) gameModuleStore.setIsForceStop(true)
        gameModuleStore.setAwaitForceStop(true)
    }

    turboStop = ({ matrix, additional }) => {
        gameModuleService.stopAnimation(matrix)
        gameModuleStore.setAdditional(additional)
    }


}


export const gameControlService = new GameControlService()